/**
 * Resolves a path inside `public/` against the configured Vite base URL,
 * so the build keeps working when served from a sub-directory.
 */
export function asset(path: string): string {
  const base = import.meta.env.BASE_URL;
  const normalized = path.replace(/^\/+/, "");

  return `${base}${base.endsWith("/") ? "" : "/"}${normalized}`;
}
